/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
/* global fetch, localStorage */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { SAVE_TRUSTWORTHY_BIOMETRY_REQUEST, success, failure } from './action';

const events = (action$, state, { AjaxRequest }) =>
  action$
    .ofType(SAVE_TRUSTWORTHY_BIOMETRY_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(({ id, file }) => {
      const formData = new FormData();

      formData.append('file', file);

      return AjaxRequest.open('post', `/admin/personcustom/people/${id}/savetrustworthy`, formData, {
        noContentType: true,
      })('tudo')
        .flatMap((response) => Observable.of(success(response)))
        .catch((err) => Observable.of(failure(err)));
    });

export default combineEpics(events);
